import EventEmitter from 'eventemitter3';

enum EventType {
    //showTopBar = 'showTopBar',
    //hideTopBar = 'hideTopBar',
    //SoftTokenStatusChanged = 'softTokenStatusChanged', // emit when soft-token register status changed
    //ApplicationDidEnterForeground = 'applicationDidEnterForeground',
    //ApplicationDidEnterBackground = 'applicationDidEnterBackground',
    //HideMCAIntro = 'hideMCAIntro', // MCA hideMCAIntro when user click "remind later"
    //RemoteNotificationReceived = 'remoteNotificationReceived',
    //showLogout = 'showLogout',
    //hideLogout = 'hideLogout',
    //NavigationCallback = 'navigationCallback', // for handle receive navigation from other modules/local devices
    //SendDataToNative = 'SendDataToNative',
    //NavigationRequest = 'navigationRequest', // for handle navigate from other module/native
    //NativeEvents = 'nativeEvents',
    //showBottomBar = 'showBottomBar',
    //hideBottomBar = 'hideBottomBar',

    ScCoreReady = 'scCoreReady', // emit when sc-core initialized
    ScPageReady = 'scPageReady', // emit when page ready

    //메뉴이동
    MenuNavigationRequest = 'menuNavigationRequest',
    //로그인페이지 이동
    LoginNavigationRequest = 'loginNavigationRequest',
    //프로그램 설치 페이지 이동
    ProgramInstallNavigationRequest = 'programInstallNavigationRequest',
    //route 이동
    RouteRequest = 'routeRequest',

    //웹뷰 관련
    WebviewClose = 'webviewClose',
    WebviewOpen = 'webviewOpen',

    //세션 관련
    SessionInvalidated = 'sessionInvalidated',
    SessionSyncCompleted = 'sessionSyncCompleted',
    UpdateSessionToken = 'updateSessionToken',

    //세션연장
    ExtendSession = 'extendSession',
    //세션만료
    ExpireSession = 'expireSession',

    //세션 타이머
    StartSessionTimer = 'startSessionTimer',
    ResetSessionTimer = 'resetSessionTimer',
    ClearSessionTimer = 'clearSessionTimer',

    CertificatePinningFailed = 'certificatePinningFailed', // emit when ssl pinning error from native
    LogoutAction = 'logoutAction', // emit logout action when user click logout button
    ForceRedirectLogin = 'forceRedirectLogin', // emit when user need to redirect to login page
    NeedLogin = 'needLogin', //로그인

    //라우트 처리 이벤트
    RoutePushAction = 'routePushAction', //route push action
    RouteReplaceAction = 'routeReplaceAction', //route replace action
    RoutePopAction = 'routePopAction', //route pop action
    RouteResetAction = 'routeResetAction', //route reset action
    RouteHistoryEmpty = 'routeHistoryEmpty', // route history stack empty

    RouteBackRequest = 'routeBackRequest',

    //로딩바
    ShowLoadingBar = 'showLoadingBar',
    HideLoadingBar = 'hideLoadingBar',

    //하단탭바 이벤트
    ShowNavbar = 'showNavbar',
    HideNavbar = 'hideNavbar',

    //CDD
    CDDBlock = 'CDDBlock',

    //외부 브라이저
    OpenWebBrowser = 'OpenWebBrowser',

    //로컬스토리지 처리 이벤트
    SetItemLocalStorage = 'setItemToLocalStorage',
    GetItemLocalStorage = 'getItemToLocalStorage',
    RemoveItemLocalStorage = 'removeItemToLocalStorage',
    ClearLocalStorage = 'clearLocalStorage',

    //상태바 색깔 변경
    ChangeStatusBarColor = 'changeStatusBarColor',

    //인뱅 스피드조회 팝업 요청
    SpeedSearchPopupRequest = 'speedSearchPopupRequest',

    //키패드 clear
    SecureKeypadClear = 'SecureKeypadClear',

    //AS-IS 관련이벤트
    UrlNavigationRequest = 'UrlNavigationRequest',

    //로그아웃 팝업
    OpenLogoutPopup = 'openLogoutPopup',

    // JWT Forbiden 처리(로그아웃 처리 > 로그아웃 페이지 이동)
    JwtForbiden = 'jwtForbiden',
}

enum TypeOfDataToNative {
    homeProductList = 'homeProductList',
    holdingOffers = 'holdingOffers',
}

class EventBus {
    private eventEmitter: EventEmitter | SCEventBus;
    private constructor() {
        if (window.scEventBus) {
            this.eventEmitter = window.scEventBus;
        } else {
            this.eventEmitter = new EventEmitter();
        }
    }
    private static instance: EventBus;

    static getInstance(): EventBus {
        if (!EventBus.instance) {
            EventBus.instance = new EventBus();
        }
        return EventBus.instance;
    }

    emit(event: EventType, ...args: unknown[]): void {
        this.eventEmitter.emit(event, ...args);
    }

    on(event: EventType, listener: (...args: unknown[]) => void) {
        this.eventEmitter.on(event, listener);
    }

    off(event: EventType, listener: (...args: unknown[]) => void) {
        this.eventEmitter.off(event, listener);
    }

    once(event: EventType, listener: (...args: unknown[]) => void) {
        this.eventEmitter.once(event, listener);
    }

    removeAllListeners(event?: EventType) {
        this.eventEmitter.removeAllListeners(event);
    }
}

export { EventBus, EventType, TypeOfDataToNative };
